import type { IUserPlanPreferences } from '@creditflowresearch/user-plan/vo/IUserPlanResponse';
import type { IDefaultPagePreferencesPayload } from '@/creditflowresearch/domain/vo/ContactSettings';

export const toCompletePreferences = (
  preferences: Partial<IUserPlanPreferences>,
): IDefaultPagePreferencesPayload => ({
  productIds: preferences.productIds ?? [],
  regionIds: preferences.regionIds ?? [],
  marketIds: preferences.marketIds ?? [],
  marketSegments: preferences.marketSegments ?? null,
});
